module.exports = __webpack_public_path__ + "img/Glass Bottle Pepsi .f2144060.png";